<style lang="scss">

.form-control {
  &::placeholder {
    color: #D1D1D1 !important;
  }

  &:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #D1D1D1;
  }

  &::-ms-input-placeholder {
    /* Microsoft Edge */
    color: #D1D1D1;
  }
}


</style>

<script>
export default {
  props: [
    'user',
  ],

  data() {
    return {
      mail: {
        title: null,
        from: null,
        from_name: null,
        subject: null,
        ready: true,
      },
      errors: {},
      modules: [],
      types: false,
      error: null,
      saving: false,
      from: null,
    };
  },

  methods: {
    save() {
      this.errors = {};

      const mail = { ...this.mail };

      mail.ready = !mail.ready;

      this.error = null;
      this.saving = true;

      this.$http.post('/mail', mail)
        .then(({ data }) => {
          this.$emit('saved', data);
        })
        .catch((response) => {
          this.saving = false;

          if (response.status === 422) {
            this.errors = response.data;
          }
        });
    },
  },
};
</script>

<template>
  <form class="px-4px" method="post" @submit.prevent="save()">
    <div class="form-group"  id="macaco">
      <label>{{ __('Título Interno') }}</label>
      <input
        class="form-control border-salesflow-outline-gray-medium placeholder-salesflow-outline-gray-medium"
        id="mail-title"
        type="text"
        :placeholder="__('Utilizado para identificar seu e-mail dentro do Salesflow')"
        v-model="mail.title"
        required="required"
      >
    </div>
    <div v-if="errors.title">
      <p class="text-danger">
        {{ errors.title[0] }}
      </p>
    </div>
    <div class="form-group">
      <label>{{ __('Assunto do e-mail') }}</label>
      <input
        class="form-control border-salesflow-outline-gray-medium placeholder-salesflow-outline-gray-medium"
        type="text"
        v-model="mail.subject"
        :placeholder="__('Assunto')"
        required="required"
      >
    </div>
    <div class="form-group">
      <label>{{ __('Nome do remetente') }}</label>
      <input
        class="form-control border-salesflow-outline-gray-medium placeholder-salesflow-outline-gray-medium"
        type="text"
        v-model="mail.from_name"
        :placeholder="user.name"
        required="required"
      >
    </div>
    <InputEmailFrom v-model="mail.from" />
    <div v-if="errors.from">
      <p class="text-danger">
        {{ errors.from[0] }}
      </p>
    </div>
    <div class="form-group">
      <div class="form-check">
        <label
          class="form-check-label"
          hidden="hidden"
        >
          <input
            class="form-control border-salesflow-outline-gray-medium placeholder-salesflow-outline-gray-medium"
            type="checkbox"
            v-model="mail.ready"
            checked="checked"
          >{{ __('Utilizar Construtor Visual') }}
        </label>
      </div>
    </div>
    <p class="text-danger" v-if="error">
      {{ error }}
    </p>
    <div class="modal-footer default-modal-footer">
      <button
        id="BUTTON-CONTINUE"
        class="btn btn-salesflow-secondary f-w-600 salesflow-text mt-3 border-pill mb-0"
        type="submit"
        :disabled="saving"
      >
        <i
          class="fa fa-circle-o-notch fa-spin"
          v-if="saving"
        /><span v-else>{{ __('Continuar') }}</span>
      </button>
    </div>
  </form>
</template>
<style lang="scss">
@import '../../../sass/variables';

#BUTTON-CONTINUE {
  border-radius: 14px;

  &:hover {
    background-color: $salesflow-secondary-hover;
    color: $white;
  }
}

.placeholder-salesflow-outline-gray-medium::placeholder {
  color: #d1d1d1; /* Change the color as desired */
  opacity: 0.5; /* Override Bootstrap's default opacity */
}


</style>
